// extracted by mini-css-extract-plugin
export default {"app-container":"App_app-container__Vu1GH","light":"App_light__-Dwrv"};